import { ReminderApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const reminderApi = new ReminderApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
